import { http } from "services";

// TODO Implement api requests
export const List = async ({ params }) => {
  // Mock data
  return {
    data: {
      total_page: 3,
      total_count: 30,
      page: 0,
      size: 10,
      data: Array.from({ length: 10 }, (_, i) => ({
        id: i,
        unique_number: `03${i + 1}`,
        service_name:
          "Vaqtincha mehnatga layoqatsizlik varaqalari ma'lumotnomalarini olish",
        organization: "O’zbekiston Respublikasi Sog'liqni saqlash vazirligi",
        users_type: "Jismoniy shaxslar",
        service_form: "An'anaviy",
        payment_type: "1 BXM",
        service_response: "Ma'lumotnoma",
        with_payment: "Mavjud",
        service_document:
          "O‘zbekiston Respublikasi Prezidentining 2023-yil 24-maydagi “Raqamli xizmatlar qamrovi va sifatini oshirish hamda soha, tarmoq va hududlarni raqamli transformatsiya qilish chora-tadbirlari to‘g‘risida”gi PQ-162-son qarori",
      })),
    },
  };
};
